import React, { useEffect, useState } from "react";
import {
  Container,
  CssBaseline,
  TextField,
  Button,
  Box,
  Typography,
  Avatar,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/index";
import { useIntl, IntlProvider, FormattedMessage } from "react-intl";
import messages from "../../locales";
import { styled } from "@mui/system";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../Themes/themes";
import kidsImage from "../../Images/kids.png";
import eyelexiaImage from "../../Images/Eyelexia.png";
const Login: React.FC = () => {
  const [language, setLanguage] = useState<"en" | "tr" | "ar">(
    (localStorage.getItem("selectedLanguage") as "en" | "tr" | "ar") || "tr"
  ); // Varsayılan dili Türkçe olarak ayarladık

  const handleChangeLanguage = (lang: "en" | "tr" | "ar") => {
    setLanguage(lang);
    localStorage.setItem("selectedLanguage", lang);
    window.location.reload();
  };
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [schoolId, setSchoolId] = useState<number | string>("");
  const intl = useIntl();
  const {
    authenticate,
    loading,
    data: authData,
    error,
  } = useAuth({
    url: "https://eyelexia.eyesoft.com.tr/api",
    //url: "http://localhost:5555",
    successFunc: (data) => {
      console.log(data); // burada userId var
      // loginlog eklemek için çağrı yap
      fetch("https://eyelexia.eyesoft.com.tr/api/login-log", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: data.id }), // userId değil user_id olabilir
      })
        .then((res) => res.text()) // JSON parse etmiyoruz, düz text alıyoruz
        .then((text) => {
          // Success! ya da hata mesajı olabilir
        })
        .catch((err) => {
          console.error("LoginLog ekleme hatası:", err);
        });

      // Sonra yönlendirme
      navigate("/schoolreportlist", {
        state: { schoolId: data.school_id, language: language },
      });
    },
    failFunc: (error) => {
      alert(
        `${intl.formatMessage({
          id: "alert",
        })}` + error.message
      );
    },
  });

  const handleLogin = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    authenticate(username, password);
  };

  return (
    <IntlProvider
      locale={language}
      messages={messages[language] as unknown as Record<string, string>}
    >
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "relative",
            minHeight: "100%",
            bgcolor: "#f5f5f5",
            backgroundImage: `url(${kidsImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "10%",
              position: "relative",
              minHeight: "100%",
              bgcolor: "#f5f5f5",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 32,
                //left: 32,
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <img
                src={eyelexiaImage}
                alt="Eyelexia Logo"
                style={{
                  height: "150px", // Logo yüksekliği (isteğe bağlı ayarlanabilir)
                  objectFit: "contain",
                }}
              />
            </Box>

            <Box
              sx={{
                width: "7.8%",
                height: "8%",
                position: "absolute",
                top: 16,
                right: 32,
                //backgroundColor: "white",
                borderRadius: "4px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              <FormControl sx={{ minWidth: 120, color: "#f5f5f5" }}>
                <InputLabel id="language-select-label">
                  {intl.formatMessage({
                    id: "language",
                  })}{" "}
                </InputLabel>
                <Select
                  labelId="language-select-label"
                  id="language-select"
                  value={language}
                  onChange={(e) =>
                    handleChangeLanguage(e.target.value as "en" | "tr" | "ar")
                  }
                  label={intl.formatMessage({
                    id: "language",
                  })}
                >
                  <MenuItem value="tr">Türkçe</MenuItem>
                  <MenuItem value="en">English</MenuItem>
                  <MenuItem value="ar">عربي</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <Box
                sx={{
                  width: { xs: "25%", sm: "50%", md: "75%", lg: "100%" },
                  height: "auto",
                  maxWidth: 360,
                  p: { xs: 1, sm: 2, md: 3, lg: 4 },
                  bgcolor: "#A6A6A6",
                  borderRadius: 2,
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Avatar sx={{ m: 2, bgcolor: "#56828C" }}>
                  <LockOutlinedIcon />
                </Avatar>
                <Typography
                  component="h1"
                  sx={{
                    fontSize: {
                      xs: "0.5rem",
                      sm: "1.0rem",
                      md: "1.5rem",
                      lg: "2.1rem",
                    },
                  }}
                  color="#56828C"
                >
                  {<FormattedMessage id="login" />}
                </Typography>
                <Box
                  component="form"
                  noValidate
                  onSubmit={handleLogin}
                  sx={{
                    width: "100%",
                    height: "100%",
                    mt: 1,
                  }}
                >
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="username"
                    label={<FormattedMessage id="username" />}
                    name="username"
                    variant="filled"
                    autoComplete="username"
                    autoFocus
                    sx={{
                      bgcolor: "white",
                      borderRadius: 2,
                    }}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label={<FormattedMessage id="password" />}
                    type="password"
                    id="password"
                    variant="filled"
                    autoComplete="current-password"
                    sx={{
                      bgcolor: "white",
                      borderRadius: 2,
                    }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 2,
                      bgcolor: "#395359",
                      fontSize: {
                        xs: "0.1rem",
                        sm: "0.5rem",
                        md: "1.0rem",
                        lg: "1.5rem",
                      },
                    }}
                    disabled={loading}
                  >
                    {loading ? (
                      <FormattedMessage id="loading" />
                    ) : (
                      <FormattedMessage id="login" />
                    )}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Container>
        </Box>
      </ThemeProvider>
    </IntlProvider>
  );

  // return (
  //   <IntlProvider
  //     locale={language}
  //     messages={messages[language] as unknown as Record<string, string>}
  //   >
  //     <ThemeProvider theme={theme}>
  //       <Box
  //         sx={{
  //           width: "100%",
  //           height: "100%",
  //           position: "relative",
  //           minHeight: "100%",
  //           bgcolor: "#f5f5f5",
  //           backgroundImage: `url(${kidsImage})`,
  //           backgroundSize: "cover",
  //           backgroundPosition: "center",
  //           backgroundRepeat: "no-repeat",
  //         }}
  //       >
  //         {/* Üst kısım (Dil Seçimi ve Eyelexia Başlığı) */}
  //         <Box
  //           sx={{
  //             width: "100%",
  //             height: "10%",
  //             position: "relative",
  //             bgcolor: "#f5f5f5",
  //           }}
  //         >
  //           {/* Dil Seçimi (Sola Alındı) */}
  //           <Box
  //             sx={{
  //               width: "7.8%",
  //               height: "8%",
  //               position: "absolute",
  //               top: 50,
  //               left: 50, // Sola alındı
  //               borderRadius: "4px",
  //               boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  //             }}
  //           >
  //             <FormControl sx={{ minWidth: 120, color: "#f5f5f5" }}>
  //               <InputLabel id="language-select-label">
  //                 {intl.formatMessage({ id: "language" })}
  //               </InputLabel>
  //               <Select
  //                 labelId="language-select-label"
  //                 id="language-select"
  //                 value={language}
  //                 onChange={(e) =>
  //                   handleChangeLanguage(e.target.value as "en" | "tr" | "ar")
  //                 }
  //                 label={intl.formatMessage({ id: "language" })}
  //               >
  //                 <MenuItem value="tr">Türkçe</MenuItem>
  //                 <MenuItem value="en">English</MenuItem>
  //                 <MenuItem value="ar">عربي</MenuItem>
  //               </Select>
  //             </FormControl>
  //           </Box>

  //           <Box
  //             sx={{
  //               position: "absolute",
  //               top: 60,
  //               right: 160, // Sağ üst köşe
  //             }}
  //           >
  //             <img
  //               src={eyelexiaImage}
  //               alt="Eyelexia Logo"
  //               style={{
  //                 height: "200px", // Logo yüksekliği (isteğe bağlı ayarlanabilir)
  //                 objectFit: "contain",
  //               }}
  //             />
  //           </Box>
  //         </Box>

  //         {/* Login Formu (Tamamen Sağa Taşındı) */}
  //         <Box
  //           sx={{
  //             display: "flex",
  //             justifyContent: "flex-end", // Login kutusunu tamamen sağa al
  //             alignItems: "center",
  //             height: "110vh",
  //             pr: 30, // Sağa boşluk ekleyerek kutunun ekrana yapışmamasını sağladım
  //           }}
  //         >
  //           <Box
  //             sx={{
  //               width: "360px", // Sabit genişlik verdim
  //               p: 4,
  //               bgcolor: "#A6A6A6",
  //               borderRadius: 2,
  //               boxShadow: 3,
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //             }}
  //           >
  //             <Avatar sx={{ m: 2, bgcolor: "#56828C" }}>
  //               <LockOutlinedIcon />
  //             </Avatar>
  //             <Typography
  //               component="h1"
  //               sx={{
  //                 fontSize: { xs: "1rem", sm: "1.5rem", md: "2rem" },
  //               }}
  //               color="#56828C"
  //             >
  //               {<FormattedMessage id="login" />}
  //             </Typography>
  //             <Box
  //               component="form"
  //               noValidate
  //               onSubmit={handleLogin}
  //               sx={{ width: "100%", mt: 1 }}
  //             >
  //               <TextField
  //                 margin="normal"
  //                 required
  //                 fullWidth
  //                 id="username"
  //                 label={<FormattedMessage id="username" />}
  //                 name="username"
  //                 variant="filled"
  //                 autoComplete="username"
  //                 autoFocus
  //                 sx={{ bgcolor: "white", borderRadius: 2 }}
  //                 value={username}
  //                 onChange={(e) => setUsername(e.target.value)}
  //               />
  //               <TextField
  //                 margin="normal"
  //                 required
  //                 fullWidth
  //                 name="password"
  //                 label={<FormattedMessage id="password" />}
  //                 type="password"
  //                 id="password"
  //                 variant="filled"
  //                 autoComplete="current-password"
  //                 sx={{ bgcolor: "white", borderRadius: 2 }}
  //                 value={password}
  //                 onChange={(e) => setPassword(e.target.value)}
  //               />
  //               <Button
  //                 type="submit"
  //                 fullWidth
  //                 variant="contained"
  //                 sx={{
  //                   mt: 3,
  //                   mb: 2,
  //                   bgcolor: "#395359",
  //                   fontSize: { xs: "1rem", sm: "1.2rem", md: "1.5rem" },
  //                 }}
  //                 disabled={loading}
  //               >
  //                 {loading ? (
  //                   <FormattedMessage id="loading" />
  //                 ) : (
  //                   <FormattedMessage id="login" />
  //                 )}
  //               </Button>
  //             </Box>
  //           </Box>
  //         </Box>
  //       </Box>
  //     </ThemeProvider>
  //   </IntlProvider>
  // );
};

export default Login;
